import React from 'react'
import styled from 'styled-components'
import { theme } from 'styled-tools'
import Image from '../image'

const AccreditationImagesWrapper = styled.div`
  border-top: 1px solid rgba(0, 0, 0, 0.12);
  padding-top: 26px;
  margin-top: 26px;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
`

const AccreditationItem = styled.div`
  text-align: center;
`

const AccreditationItemIcon = styled.div`
  width: 24px;
  height: 24px;
  margin: 0 auto 12px;

  img {
    width: 24px;
    height: 24px;
    display: block;
  }
`

const AccreditationItemText = styled.p`
  text-align: center;
  font-family: ${theme('typography.paragraph.fontFamily')};
  font-size: 16px;
  font-style: normal;
  margin: 0;
  height: 40px;
`

const AccreditationImages = ({ images }) => {
  if (!images || images.length === 0) return null

  return (
    <AccreditationImagesWrapper>
      {images.map((item, index) => (
        <AccreditationItem key={item.id || item.name || index}>
          {item.image && (
            <AccreditationItemIcon>
              <Image value={item.image} />
            </AccreditationItemIcon>
          )}
          {item.description && (
            <AccreditationItemText>{item.description}</AccreditationItemText>
          )}
        </AccreditationItem>
      ))}
    </AccreditationImagesWrapper>
  )
}

export default AccreditationImages
